// frontend/src/components/support/PaypalSection.js

import { PayPalButtons, PayPalScriptProvider } from "@paypal/react-paypal-js";

import { useNavigate } from "react-router-dom";

const API_URL = process.env.REACT_APP_API_URL;

const PAYPAL_CLIENT_ID = process.env.REACT_APP_PAYPAL_CLIENT_ID;

export default function PaypalSection({
  email,
  packageId,
  packageName,
  packagePrice,
  tip,
  disabled,
}) {
  const navigate = useNavigate();

  async function createOrder() {
    if (disabled) {
      throw new Error("Invalid email");
    }

    const response = await fetch(`${API_URL}/paypal/create-order`, {
      method: "POST",

      headers: {
        "Content-Type": "application/json",
      },

      body: JSON.stringify({
        email,
        packageId,
        tip,
      }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Create order failed");
    }

    return data.orderId;
  }

  async function onApprove(data) {
    const response = await fetch(`${API_URL}/paypal/capture-order`, {
      method: "POST",

      headers: {
        "Content-Type": "application/json",
      },

      body: JSON.stringify({
        orderId: data.orderID,
      }),
    });

    const result = await response.json();

    if (!result.success) {
      alert("Payment failed");
      return;
    }

    navigate("/payment-success", {
      state: {
        orderId: data.orderID,
        packageId,
        packageName,
        packagePrice,
        claimToken: result.claimToken,
      },
    });
  }

  return (
    <div
      style={{
        marginTop: 40,

        opacity: disabled ? 0.55 : 1,

        pointerEvents: disabled ? "none" : "auto",
      }}
    >
      <PayPalScriptProvider
        options={{
          clientId: PAYPAL_CLIENT_ID,

          currency: "USD",
        }}
      >
        <PayPalButtons
          createOrder={createOrder}
          onApprove={onApprove}
          disabled={disabled}
        />
      </PayPalScriptProvider>
    </div>
  );
}
